import { useEffect } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { usePatch } from 'hooks';
import { manageMembers } from 'services/api';
import {
  getActiveList,
  getSelectedMemberIds,
  getSelectedMembers,
  getView,
} from 'selectors/lists';
import { clearSelectedMembers } from 'actions/lists';

const RemoveFrom = ({ onClose }) => {
  const dispatch = useDispatch();
  const activeList = useSelector(getActiveList);
  const selectedMemberIds = useSelector(getSelectedMemberIds);
  const selectedMembers = useSelector(getSelectedMembers);
  const view = useSelector(getView);
  const [{ res: removeRes, loading }, patchMembers] = usePatch({
    url: manageMembers(activeList.id, view),
  });

  useEffect(() => {
    if (removeRes) {
      dispatch(clearSelectedMembers());
      onClose({ fetchMembers: true });
    }
  }, [dispatch, removeRes, onClose]);

  const handleRemove = () => {
    patchMembers({
      shouldRemove: true,
      researcherIds: selectedMemberIds,
      memberIds: selectedMemberIds,
      excludedFromAllResearcherIds: Object.keys(selectedMembers.exclude),
      excludedFromAllMemberIds: Object.keys(selectedMembers.exclude).map(
        x => +x
      ),
    });
  };

  return (
    <Modal
      open
      title={`Remove from ${activeList.name}`}
      onCancel={onClose}
      okText='Yes'
      onOk={handleRemove}
      okButtonProps={{ disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      Would you like to remove the selected members from {activeList.name}?
    </Modal>
  );
};

export default RemoveFrom;
